/**
 * The icon set that CMS content is allowed to reference.
 *
 * Services and the "Why Athena" features store an icon *name* as a string, so
 * the component has to look it up at runtime. Doing that with
 * `import * as Icons from "lucide-react"` works, but a dynamic property access
 * defeats tree-shaking entirely — the bundler cannot prove which icons are used
 * and ships all ~1,000 of them to every visitor.
 *
 * Naming them explicitly here keeps the lookup dynamic for the CMS while
 * letting the bundler drop everything else. Keep this list in step with
 * `SERVICE_ICONS` in `admin/schemas.js`.
 */

import {
  Award,
  Beaker,
  Brain,
  CalendarClock,
  Compass,
  GraduationCap,
  Handshake,
  HeartHandshake,
  Headset,
  Lightbulb,
  Microscope,
  PackageCheck,
  Percent,
  ShieldCheck,
  Sparkles,
  Tag,
  Truck,
  Users,
  Wrench,
} from "lucide-react";

const ICONS = {
  // Services and "Why Athena"
  Beaker,
  CalendarClock,
  Compass,
  GraduationCap,
  Headset,
  Microscope,
  PackageCheck,
  Percent,
  ShieldCheck,
  Tag,
  Truck,
  Wrench,
  // About page core values
  Award,
  Brain,
  Handshake,
  HeartHandshake,
  Lightbulb,
  Users,
  // Fallback
  Sparkles,
};

/** Resolve a stored icon name, falling back to a neutral icon. */
export const iconFor = (name) => ICONS[name] || Sparkles;

export default ICONS;
